import useSWR from 'swr'

import * as T from 'types'

import { fetch } from '../../fetchers'

export const usePricingPackagesForState = (stateCode?: string) => {
  const key = stateCode ? `/pricingpackages?includeInactive=false&stateCode=${stateCode}` : null
  const response = useSWR<T.IPricingPackage[]>(key, fetch)

  const sortedPricingPackages = response?.data?.sort(
    (packageA: any, packageB: any) => packageA.price - packageB.price,
  )
  return {
    ...response,
    pricingPackages: sortedPricingPackages, // alias 1
    statePricingPackages: sortedPricingPackages, // alias 2
  }
}
